module.exports = __webpack_public_path__ + "static/media/instagram-walink.82222bf2.jpeg";